import styled from 'styled-components';
import ListingLibHighlightString from 'framework-listing-lib/table/ListingLibHighlightString';
import UITruncateString from 'UIComponents/text/UITruncateString';
import SubmissionsAppLink from 'FormsUI/components/common/SubmissionsAppLink';
import { FormType } from 'FormsUI/components/dashboard/frameworkTable/types';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { getHrefForFormType } from 'FormsUI/utils/FormUtils';
import ViewNonHubSpotInformationAction from './HoverContent/actions/ViewNonHubSpotInformationAction';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledNameLink = styled.div.withConfig({
  displayName: "NameLink__StyledNameLink",
  componentId: "sc-10al1v6-0"
})(["margin-bottom:4px;vertical-align:middle;"]);
const NameLink = ({
  name,
  formType,
  formId,
  isPublished
}) => {
  const href = getHrefForFormType(formId, formType, isPublished);
  const text = /*#__PURE__*/_jsx(UITruncateString, {
    children: /*#__PURE__*/_jsx(ListingLibHighlightString, {
      value: name,
      "data-test-id": "form-row__name"
    })
  });
  const textWithLink = (() => {
    switch (formType) {
      case FormType.CAPTURED:
        return /*#__PURE__*/_jsx(ViewNonHubSpotInformationAction, {
          formId: formId,
          trackAction: trackDashboardInteraction,
          children: text
        });
      default:
        return /*#__PURE__*/_jsx(SubmissionsAppLink, {
          formId: formId,
          href: href,
          use: "blue",
          "data-test-id": "form-row__name-link",
          children: text
        });
    }
  })();
  return /*#__PURE__*/_jsx(StyledNameLink, {
    children: textWithLink
  });
};
export default NameLink;